export function cssPropertiesToString(styles: any, indent: number = 0): string {
  const indentString = " ".repeat(indent);
  const entries = Object.entries(styles);

  return entries
    .map(([property, value], index) => {
      const kebabCaseProperty = property
        .replace(/([A-Z])/g, "-$1")
        .toLowerCase();

      const valueString =
        typeof value === "object"
          ? ` {\n${cssPropertiesToString(value, indent + 2)}}`
          : `: ${value};`;

      const isLastEntry = index === entries.length - 1;
      const isNewLine = !isLastEntry || indent !== 0 ? "\n" : "";

      return `${indentString}${kebabCaseProperty}${valueString}${isNewLine ? "\n" : ""}`;
    })
    .join("");
}
